export default __webpack_public_path__ + "static/media/14_tag_connecting-room.72829ecb.svg";